import React, { useEffect, useState } from 'react'
import { motion } from "framer-motion";
import { useLocation, useNavigate } from 'react-router-dom';
import PlusSquared from "../../Images/PlusSquared.svg"
import PlusOutlined from "../../Images/PlusOutlined.svg"
import FolderSvg from "../../Images/folder.svg"
import axios from 'axios';
import "./styles.css"
import { CustomSelect } from '../../Components/CustomSelect';
import FormModal from '../../Components/FormModal';
import { M_URL, MAIN_URL_LOCAL, MAIN_URL } from '../../constants';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../../Components/RefreshToken/RefreshToken';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

// LESSON:
//   Step 1 → POST /courses/lessons/add
//              (photo?, course_id, chapter_id)
//   Step 2 → POST /courses/lessons/:lesson_id/translations/add   — ixtiyoriy, har bir til uchun alohida
//              (pdf, language, video_url, title, description, text_of_video, indpndnt_lrng_pdf?)

const LANGUAGES = [
    { value: 'uz', label: 'UZ' },
    { value: 'en', label: 'EN' },
    { value: 'ru', label: 'RU' },
];

const Preview = () => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const courseFromQuery = searchParams.get("course") || "";
    const TOKEN = localStorage.getItem('admin_token');

    // ─── Modal ────────────────────────────────────────────────────────────────
    const [isModalOpen, setModalOpen] = useState(false);
    const [type, setType] = useState('course');

    // ─── Course / Chapter selects ─────────────────────────────────────────────
    const [coursesOpts, setCoursesOpts] = useState([]);
    const [chaptersOpts, setChaptersOpts] = useState([]);
    const [changedCourse, setChangedCourse] = useState(courseFromQuery);
    const [changedChapter, setChangedChapter] = useState('');

    // ─── Video ────────────────────────────────────────────────────────────────
    const [videoUrl, setVideoUrl] = useState(null);

    // ─── Step ─────────────────────────────────────────────────────────────────
    const [step, setStep] = useState(1);
    const [createdLessonId, setCreatedLessonId] = useState(null);
    const [submitLoading, setSubmitLoading] = useState(false);

    // ─── Step 1 fields ────────────────────────────────────────────────────────
    const [photoFile, setPhotoFile] = useState(null);
    const [photoFileName, setPhotoFileName] = useState('');
    const [photoFileURL, setPhotoFileURL] = useState('');
    const [photoInspect, setPhotoInspect] = useState(false);

    // ─── Step 2 (translations) ────────────────────────────────────────────────
    const [savedTranslations, setSavedTranslations] = useState([]);
    const [currentTrans, setCurrentTrans] = useState({
        language: '',
        title: '',
        description: '',
        text_of_video: '',
        pdf: null,
        indpndnt_lrng_pdf: null,
    });
    const [pdfFileName, setPdfFileName] = useState('');
    const [indPdfFileName, setIndPdfFileName] = useState('');
    const [pdfInspect, setPdfInspect] = useState(false);
    const [indPdfInspect, setIndPdfInspect] = useState(false);
    const [translationLoading, setTranslationLoading] = useState(false);

    // ─── Init video URL ───────────────────────────────────────────────────────
    useEffect(() => {
        const videoURL = localStorage.getItem("videoUrl");
        setVideoUrl(videoURL || null);
    }, []);

    // ─── Sync course from query ───────────────────────────────────────────────
    useEffect(() => {
        if (courseFromQuery) setChangedCourse(courseFromQuery);
    }, [courseFromQuery]);

    // ─── Fetch courses ────────────────────────────────────────────────────────
    useEffect(() => {
        api.get('/courses/for-select', {
            headers: { Accept: 'application/json', Authorization: `Bearer ${TOKEN}` },
        })
            .then((res) => {
                setCoursesOpts(
                    res.data?.map((c) => ({ value: c.id, label: c.title })) || []
                );
            })
            .catch((err) => console.error('Courses fetch error:', err));
    }, [isModalOpen]);

    // ─── Fetch chapters when course changes ───────────────────────────────────
    useEffect(() => {
        if (!changedCourse) return;
        api.get(`/courses/chapters?course_id=${changedCourse}`, {
            headers: { Authorization: `Bearer ${TOKEN}` },
        })
            .then((res) => {
                setChaptersOpts(
                    res.data?.map((ch) => ({ value: ch.id, label: ch.title })) || []
                );
            })
            .catch((err) => console.error('Chapters fetch error:', err));
    }, [changedCourse]);

    // ─── Course created from modal ────────────────────────────────────────────
    const handleCourseCreated = (data) => {
        if (!data) return;
        const opt = { value: data.id, label: data.title };
        setCoursesOpts((prev) => [...prev, opt]);
        setChangedCourse(data.id);
        setSearchParams({ course: data.id });
    };

    const handleNewChapter = (chapters) => {
        setChaptersOpts(chapters);
    };

    // ─── Photo ────────────────────────────────────────────────────────────────
    const handlePhotoChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const allowed = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
        if (!allowed.includes(file.type)) {
            setPhotoInspect(true);
            e.target.value = '';
            return;
        }
        setPhotoInspect(false);
        setPhotoFile(file);
        setPhotoFileName(file.name);
        setPhotoFileURL(URL.createObjectURL(file));
    };

    // ─── PDF helpers ──────────────────────────────────────────────────────────
    const handlePdfChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        if (file.type !== 'application/pdf') {
            setPdfInspect(true);
            e.target.value = '';
            return;
        }
        setPdfInspect(false);
        setCurrentTrans((prev) => ({ ...prev, pdf: file }));
        setPdfFileName(file.name);
    };

    const handleIndPdfChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        if (file.type !== 'application/pdf') {
            setIndPdfInspect(true);
            e.target.value = '';
            return;
        }
        setIndPdfInspect(false);
        setCurrentTrans((prev) => ({ ...prev, indpndnt_lrng_pdf: file }));
        setIndPdfFileName(file.name);
    };

    // =========================================================================
    // STEP 1 → POST /courses/lessons/add
    // =========================================================================
    const handleCreateLesson = () => {
        if (!changedCourse) { toast.warn('Kursni tanlang'); return; }
        if (!changedChapter) { toast.warn('Chapterni tanlang'); return; }

        setSubmitLoading(true);
        const fd = new FormData();
        fd.append('course_id', changedCourse);
        fd.append('chapter_id', changedChapter);
        if (photoFile) fd.append('photo', photoFile);

        axios.post(`${MAIN_URL}/courses/lessons/add`, fd, {
            headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${TOKEN}` },
        })
            .then((res) => {
                setCreatedLessonId(res.data?.id);
                setSubmitLoading(false);
                setStep(2);
            })
            .catch((err) => {
                console.error('Create lesson error:', err);
                toast.error('Darsni yaratishda xatolik');
                setSubmitLoading(false);
            });
    };

    // =========================================================================
    // STEP 2 → POST /courses/lessons/:lesson_id/translations/add
    // =========================================================================
    const handleSaveTranslation = async () => {
        if (!currentTrans.language) { toast.warn('Tilni tanlang'); return; }
        if (!currentTrans.title.trim()) { toast.warn('Sarlavhani kiriting'); return; }
        if (!currentTrans.description.trim() && !currentTrans.description.replace(/<[^>]*>/g, '').trim()) {
            toast.warn('Tavsifni kiriting'); return;
        }
        if (!currentTrans.pdf) { toast.warn('PDF faylni yuklang'); return; }
        if (!videoUrl) { toast.warn('Video URL topilmadi'); return; }
        if (savedTranslations.find((t) => t.language === currentTrans.language)) {
            toast.warn('Bu til allaqo\'shilgan');
            return;
        }

        setTranslationLoading(true);
        const fd = new FormData();
        fd.append('pdf', currentTrans.pdf);
        fd.append('language', currentTrans.language);
        fd.append('video_url', videoUrl);
        fd.append('title', currentTrans.title);
        fd.append('description', currentTrans.description);
        fd.append('text_of_video', localStorage.getItem('textOfVideo') || '');
        if (currentTrans.indpndnt_lrng_pdf) fd.append('indpndnt_lrng_pdf', currentTrans.indpndnt_lrng_pdf);

        try {
            await axios.post(
                `${MAIN_URL}/courses/lessons/${createdLessonId}/translations/add`,
                fd,
                { headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${TOKEN}` } }
            );
            toast.success(`${currentTrans.language.toUpperCase()} tarjimasi saqlandi!`);
            setSavedTranslations((prev) => [...prev, { language: currentTrans.language, title: currentTrans.title }]);
            setCurrentTrans({ language: '', title: '', description: '', text_of_video: '', pdf: null, indpndnt_lrng_pdf: null });
            setPdfFileName('');
            setIndPdfFileName('');
        } catch (err) {
            console.error('Translation error:', err);
            toast.error('Tarjimani saqlashda xatolik');
        } finally {
            setTranslationLoading(false);
        }
    };

    const handleFinish = () => {
        if (
            savedTranslations.length === 0 &&
            (currentTrans.title.trim() || currentTrans.language)
        ) {
            toast.warn('"Tarjimani saqlash" tugmasini bosing yoki formni bo\'shatib chiqing');
            return;
        }
        localStorage.removeItem('videoUrl');
        navigate('/new-lesson');
    };

    // ─── Available languages ──────────────────────────────────────────────────
    const availableLanguages = LANGUAGES.filter(
        (l) => !savedTranslations.find((t) => t.language === l.value)
    );

    // =========================================================================
    // RENDER
    // =========================================================================
    return (
        <motion.div
            initial={{ opacity: 0, transform: 'translateX(20%)' }}
            animate={{ opacity: 1, transform: 'translateX(0)' }}
            exit={{ opacity: 0, transform: 'translateX(-20%)' }}
            transition={{ duration: 0.5 }}
        >
            {videoUrl ? (
                <div className="preview-container">
                    <h1>Your Video is Ready!</h1>
                    <video className="generated-video" style={{ marginBottom: '20px' }} controls>
                        <source src={videoUrl} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>

                    {/* ============================================================
                        STEP 1 – Lesson asosi
                    ============================================================ */}
                    {step === 1 && (
                        <div className="edit-lesson-form">
                            <h3 className="step-title">Step 1: Dars ma'lumotlari</h3>

                            {/* Photo */}
                            <div className="addBlock">
                                <div className="add-file-container addPhoto" style={{ margin: '10px', width: '30%' }}>
                                    <label className="add-filee">
                                        <span>Add lesson photo</span>
                                        <img src={PlusSquared} alt="" />
                                        <input type="file" name="photo" accept="image/*" style={{ display: 'none' }} onChange={handlePhotoChange} />
                                    </label>
                                    {photoInspect && <span className="error-file">Faqat rasm fayl yuklang!</span>}
                                    {photoFileName && photoFileURL && (
                                        <div className="uploaded-file-container img-view">
                                            <img src={FolderSvg} alt="" />
                                            <a href={photoFileURL} target="_blank" rel="noopener noreferrer">
                                                {photoFileName.length > 10 ? photoFileName.slice(0, 10) + '..' : photoFileName}
                                            </a>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Course / Chapter selects */}
                            <div className="add-file-left" style={{ marginBottom: "20px" }}>
                                <div className="form-group">
                                    <div style={{ display: "flex" }}>
                                        <select
                                            className="custom-select"
                                            value={changedCourse}
                                            onChange={(e) => {
                                                setChangedCourse(e.target.value);
                                                setSearchParams({ course: e.target.value });
                                            }}
                                            required
                                        >
                                            <option value="">Choose course</option>
                                            {coursesOpts.map((c) => (
                                                <option key={c.value} value={c.value}>{c.label}</option>
                                            ))}
                                        </select>
                                        <div className="edit-plus" onClick={() => { setModalOpen(true); setType('course'); }}>
                                            <img src={PlusOutlined} alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group" style={{ display: "flex" }}>
                                    <div style={{ display: "flex" }}>
                                        <select
                                            className="custom-select"
                                            value={changedChapter}
                                            onChange={(e) => setChangedChapter(e.target.value)}
                                            required
                                        >
                                            <option value="">Choose chapter</option>
                                            {chaptersOpts.map((ch) => (
                                                <option key={ch.value} value={ch.value}>{ch.label}</option>
                                            ))}
                                        </select>
                                        <div className="edit-plus" onClick={() => { setModalOpen(true); setType('chapter'); }}>
                                            <img src={PlusOutlined} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Buttons */}
                            <div className="btns-container">
                                <button className="preview-add-btn" onClick={() => navigate('/new-lesson')}>
                                    Generate Another Video
                                </button>
                                <button
                                    className="preview-add-btn primary-btn"
                                    onClick={handleCreateLesson}
                                    disabled={submitLoading}
                                >
                                    {submitLoading ? 'Loading...' : 'Next →'}
                                </button>
                            </div>
                        </div>
                    )}

                    {/* ============================================================
                        STEP 2 – Translations (ixtiyoriy)
                    ============================================================ */}
                    {step === 2 && (
                        <div className="edit-lesson-form">
                            <h3 className="step-title">Step 2: Tarjimalar qo'shish</h3>

                            {/* Saved badges */}
                            {savedTranslations.length > 0 && (
                                <div className="saved-translations">
                                    {savedTranslations.map((t) => (
                                        <span key={t.language} className="translation-badge">
                                            {t.language.toUpperCase()} ✓ — {t.title}
                                        </span>
                                    ))}
                                </div>
                            )}

                            <p className="translation-hint">
                                {savedTranslations.length === 0
                                    ? 'Tarjima qo\'shish ixtiyoriy. Xohlasangiz qo\'shing yoki "Finish" ni bosing.'
                                    : 'Yana til qo\'shishingiz yoki "Finish" ni bosishingiz mumkin.'}
                            </p>

                            {availableLanguages.length > 0 && (
                                <div className="translation-form">
                                    {/* Language */}
                                    <div className="form-group">
                                        <select
                                            className="custom-select"
                                            value={currentTrans.language}
                                            onChange={(e) => setCurrentTrans((prev) => ({ ...prev, language: e.target.value }))}
                                        >
                                            <option value="" hidden>Til tanlang</option>
                                            {availableLanguages.map((l) => (
                                                <option key={l.value} value={l.value}>{l.label}</option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Title */}
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            className="custom-select video-title-add"
                                            placeholder="Dars sarlavhasi"
                                            value={currentTrans.title}
                                            onChange={(e) => setCurrentTrans((prev) => ({ ...prev, title: e.target.value }))}
                                        />
                                    </div>

                                    {/* Description */}
                                    <div className="form-group">
                                        <ReactQuill
                                            value={currentTrans.description}
                                            onChange={(val) => setCurrentTrans((prev) => ({ ...prev, description: val }))}
                                            className="word-text"
                                            placeholder="Dars tavsifi..."
                                        />
                                    </div>

                                    {/* PDF (required) */}
                                    <div style={{display: "flex", width: "100%", justifyContent: "space-between"}}>
                                        <div className="add-file-container file-width">
                                            <label className="add-file">
                                                <span>{pdfFileName || 'Add Lesson material PDF *'}</span>
                                                <img src={PlusSquared} alt="" />
                                                <input type="file" accept="application/pdf" style={{ display: 'none' }} onChange={handlePdfChange} />
                                            </label>
                                            {pdfInspect && <span style={{ color: 'red' }}>Faqat PDF fayl yuklang!</span>}
                                            {pdfFileName && (
                                                <div className="uploaded-file-container">
                                                    <img src={FolderSvg} alt="" />
                                                    <span>{pdfFileName.length > 20 ? pdfFileName.slice(0, 20) + '...' : pdfFileName}</span>
                                                </div>
                                            )}
                                        </div>

                                        {/* Independent learning PDF (optional) */}
                                        <div className="add-file-container file-width" style={{ marginTop: '10px' }}>
                                            <label className="add-file">
                                                <span>{indPdfFileName || 'Independent learning PDF (ixtiyoriy)'}</span>
                                                <img src={PlusSquared} alt="" />
                                                <input type="file" accept="application/pdf" style={{ display: 'none' }} onChange={handleIndPdfChange} />
                                            </label>
                                            {indPdfInspect && <span style={{ color: 'red' }}>Faqat PDF fayl yuklang!</span>}
                                            {indPdfFileName && (
                                                <div className="uploaded-file-container">
                                                    <img src={FolderSvg} alt="" />
                                                    <span>{indPdfFileName.length > 20 ? indPdfFileName.slice(0, 20) + '...' : indPdfFileName}</span>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Save translation */}
                                    <button
                                        type="button"
                                        className="btn-save-translation"
                                        onClick={handleSaveTranslation}
                                        disabled={translationLoading}
                                    >
                                        {translationLoading ? 'Saqlanmoqda...' : '+ Tarjimani saqlash'}
                                    </button>
                                </div>
                            )}

                            {availableLanguages.length === 0 && (
                                <p className="translation-hint">Barcha tillar qo'shildi.</p>
                            )}

                            {/* Finish buttons */}
                            <div className="btns-container">
                                <button className="preview-add-btn" onClick={() => navigate('/new-lesson')}>
                                    Generate Another Video
                                </button>
                                <button
                                    className="preview-add-btn primary-btn"
                                    onClick={handleFinish}
                                >
                                    Finish
                                </button>
                            </div>
                        </div>
                    )}

                    {/* FormModal for course/chapter creation */}
                    <FormModal
                        setChangedChapter={setChangedChapter}
                        handleNewChapter={handleNewChapter}
                        newCourse={handleCourseCreated}
                        courseChangeId={changedCourse}
                        isModalOpen={isModalOpen}
                        setModalOpen={setModalOpen}
                        isCourseModal={type === 'course'}
                    />
                </div>
            ) : (
                <div className="container">Loading video...</div>
            )}
        </motion.div>
    );
};

export default Preview;